import React, { PureComponent } from 'react'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'

import getString, { target } from './config/strings'
import { Switch, Route } from 'react-router-dom'

import ervlogo from './ervlogo.png'
import './App.css'

import Alert from './components/alert'
import Login from './components/login'
import TariffPage from './components/tariffsPage'
import ResetPassword from './components/resetPassword'

const styles = {
  palette: {
    primary: {
      light: '#f4e64a',
      main: '#BEB400',
      dark: '#8a8500',
      contrastText: '#ffffff'
    },
    secondary: {
      light: '#4466a7',
      main: '#003c78',
      dark: '#00174b',
      contrastText: '#ffffff'
    },
    header: {
      main: '#767676'
    }
  }
}

function makeMuiTheme (styleConfig) {
  return createMuiTheme(
    styleConfig
  )
}

class App extends PureComponent {
  constructor (props) {
    super(props)

    this.muiTheme = makeMuiTheme(styles)

    this.state = {
      auth: null
    }

    let lang = null

    if (window.location.search) {
      let search = window.location.search.substring(1)
      let parts = search.split(/&/)
      parts.forEach(function (part) {
        let pair = part.split(/=/)
        if (pair && pair.length && pair.length === 2) {
          if (decodeURIComponent(pair[0]).toLowerCase() === 'lang') {
            lang = decodeURIComponent(pair[1]).toLowerCase().substring(0, 2)
          }
        }
      })
    }

    if (!lang || target.supportedLanguages.indexOf(lang) === -1) {
      lang = App.browserLocale()
      if (lang && typeof lang === 'string') {
        lang = lang.substring(0, 2).toLowerCase()
      } else {
        lang = null
      }
    }
    if (lang && target.supportedLanguages.indexOf(lang) >= 0) {
      target.choosenLanguage = lang
    }
  }

  static browserLocale () {
    let lang

    if (navigator.languages && navigator.languages.length) {
      // latest versions of Chrome and Firefox set this correctly
      lang = navigator.languages[0]
    } else if (navigator.userLanguage) {
      // IE only
      lang = navigator.userLanguage
    } else {
      // latest versions of Chrome, Firefox, and Safari set this correctly
      lang = navigator.language
    }

    return lang
  }

  setLogin (auth) {
    this.setState({auth: auth})
  }

  renderMain (props) {
    if (this.state.auth)
      return <TariffPage parent={this} auth={this.state.auth}/>
    else
      return <Login parent={this}/>
  }

  render () {
    return (
      <MuiThemeProvider theme={this.muiTheme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>

          <div className="App">
            <AppBar position="static" color="default">
              <Toolbar>
                <img src={ervlogo} className="App-logo" alt="logo"/>
                <Typography variant="h6" color="inherit" className="flex" style={{paddingLeft: '2em'}}>
                  {getString('APP_TITLE')}
                </Typography>
                {this.state.auth &&
                <Button color="inherit" onClick={() => {this.setState({auth: null})}}>{getString('LOGOUT')}</Button>}
              </Toolbar>
            </AppBar>

            <Switch>
              <Route exact path='/' render={(props) => {return this.renderMain(props)}}/>
              <Route path='/resetPassword/:token/:signature'
                     render={(props) => {return <ResetPassword {...props} parent={this}/>}}/>
            </Switch>
            <Alert/>
          </div>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    )
  }
}

export default App
